import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { rem } from '@mantine/core';

type WrapperProps = {
  vertical?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  padding: 60px 20px 60px 20px;
  background-color: black;

  & > div {
    display: flex;
    flex-direction: column;
    gap: 40px;
    max-width: 82.5rem;
    margin: auto;

    /* Video thumbnail */
    & > div:first-of-type {
      margin-top: 40px;
      max-width: ${(props) => (props.vertical ? '' : '70rem')};
      width: 100%;
      margin: auto;
      border-radius: 20px;
    }

    & > h1 {
      font-size: ${rem(24)};
      font-weight: 700;
    }

    div.ql-editor {
      padding: 0px;

      * {
        font-size: ${rem(16)};
        font-weight: 400;
        background-color: transparent;
        padding: 0px;
      }

      h1 {
        font-size: ${rem(20)};
        font-weight: 700;
      }

      h2 {
        font-size: ${rem(18)};
        font-weight: 600;
      }

      h3 {
        font-weight: 500;
      }
    }
  }
`;

export const RelatedVideosSection = styled.section<{ videosLength: number }>`
  h2 {
    font-size: ${rem(24)};
    font-weight: 700;
    margin-bottom: 40px;
    text-align: center;
  }

  ul {
    list-style: none;
    display: grid;
    gap: 30px;

    justify-content: center;
    align-items: center;
    ${(props) =>
      props.videosLength === 1
        ? css`
            max-width: 40rem;
            grid-template-columns: 1fr;
            margin: auto;
          `
        : css`
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          `}
  }

  @media screen and (max-width: 400px) {
    ul {
      grid-template-columns: 1fr;
    }
  }
`;
